import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  Resolve,
  RouterStateSnapshot
} from '@angular/router';
import { EMPTY, Observable, of } from 'rxjs';
import { catchError, mergeMap, take } from 'rxjs/operators';
 
import { ProductModel } from '../models/product.model';
import { DataService } from '../services/data/data.service';
 
@Injectable({
  providedIn: 'root',
})

export class MyProductsResolverService implements Resolve<any> {

  constructor(private dataService: DataService) {
  }
 
  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<ProductModel[]> | Observable<never> {
    let id = route.paramMap.get('profileId');
    // console.log('MyProductsResolverService',id);
    return this.dataService.getMyProducts(id).pipe(
        take(1),
        mergeMap(item => {
          // console.log('products resolver',item);
          if (item) {
            return of(item);
          } else { // id not found
            console.log('empty');
            return EMPTY;
          }
        }),
        catchError((error,obs)=>{
          console.log(error,obs);
          return obs;
        }),
      );
  }
}